<template>
  <el-dialog v-loading="isLoading" title="拣货" :visible.sync="dialogFormVisible" width="60vw" height="100vh" top="2vh"
    :fullscreen="true" :close-on-click-modal="false" :close-on-press-escape="false" @close="close">
    <audio ref="audioPlayer" src="@/assets/audio.mp3" controls style="display: none" />
    <audio ref="successAudioPlayer" src="@/assets/success.mp3" controls style="display: none" />
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="库位编号">
        <el-input ref="storageLocation" v-model.trim="form.storage_location" clearable placeholder="请扫描"
          @keyup.enter.native="handleQuery"></el-input>
      </el-form-item>
      <el-form-item label="包裹单号">
        <el-input ref="orderCode" v-model.trim="form.order_code" clearable placeholder="请扫描"
          @keyup.enter.native="handleQueryOrderCode"></el-input>
      </el-form-item>
    </el-form>
    <el-table v-loading="listLoading" :data="tableData" border style="width: 100%" :cell-style="setRowStyle">
      <!-- 所在库位 -->
      <el-table-column align="center" prop="storage_location" label="所在库位" />
      <!-- 商品编号 -->
      <el-table-column align="center" prop="order_code" label="原包裹单号" />
      <!-- 任务编号-->
      <el-table-column align="center" prop="task_code" label="任务编号" />
      <!-- 拣货状态 -->
      <el-table-column align="center" label="拣货状态">
        <template slot-scope="{ row }">
          <div v-if="row.status == 0">待拣货</div>
          <div v-if="row.status == 1">拣货完成</div>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">返回</el-button>
      <!-- <el-button type="primary" @click="save">确 定</el-button> -->
    </div>
  </el-dialog>
</template>

<script>
import { task_picking, buyStatus, buyUpdate, task_detail, pda_task_picking } from '@/api/xgcApi'
export default {
  name: 'UserManagementEdit',
  components: {},
  data() {
    return {
      form: {
        storage_location: '',
        order_code: ''
      },
      title: '',
      listLoading: false, // 请求数据加载
      srcList: [],
      tableData: [],
      dialogFormVisible: false,
      isLoading: false,
      taskCode: '',
      rules: {
        price: [
          { required: true, trigger: 'blur', message: '' },
        ],
      },
      daifu: false,
    }
  },

  created() { },
  methods: {
    // 根据条件设置样式，例如改变背景色和字体颜色等。
    setRowStyle({ row, rowIndex }) {
      if (row.status == 0) {
        return {
          backgroundColor: ''
        }
      } else if (row.status == 1) {
        return {
          backgroundColor: '#55ff7f'
        }
      } else {
        return {
          backgroundColor: ''
        }
      }
    },

    async showEdit(row) {
      if (row.type == 2) {
        this.daifu = true
      } else {
        this.daifu = false
      }
      this.srcList = []
      this.dialogFormVisible = true
      this.title = '编辑'
      this.taskCode = row.task_code
       this.$nextTick(() => {
              const input = this.$refs.storageLocation
              input.focus()
            })
      this.taskDetail(row.task_code)
      // const { data } = await task_detail({ task_code:row.task_code })
      // // this.form = data
      // this.tableData = data
    },

    playSuccessAudio() {
      this.$refs.successAudioPlayer.play()
    },
    taskDetail(code) {
      task_detail({ task_code: code }).then(res => {
        this.tableData = res.data
      })
    },
    handleQuery() {
      const input = this.$refs.orderCode
      input.focus()
    },
    handleQueryOrderCode() {
      pda_task_picking(this.form).then(res => {
        this.$baseMessage(res.msg, 'success')
        this.form.storage_location = ''
        this.form.order_code = ''
           this.$nextTick(() => {
              const input = this.$refs.storageLocation
              input.focus()
            })
            this.playSuccessAudio()
        this.taskDetail(this.taskCode)
      })
    },






    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const { msg } = await buyUpdate(this.form)
          this.$baseMessage(msg, 'success')
          this.$emit('fetch-data')
          this.close()
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style scoped>
:deep .el-select>.el-input {
  width: 430px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
